export const BANKS = {
  NH농협은행: 'NH농협은행',
  KB국민은행: 'KB국민은행',
  신한은행: '신한은행',
  KEB하나은행: 'KEB하나은행',
  우리은행: '우리은행',
  IBK기업은행: 'IBK기업은행',
  KDB산업은행: 'KDB산업은행',
  SC제일은행: 'SC제일은행',
  부산은행: '부산은행',
  DGB대구은행: 'DGB대구은행',
  SH수협은행: 'SH수협은행',
  BNK경남은행: 'BNK경남은행',
  광주은행: '광주은행',
  전북은행: '전북은행',
  카카오뱅크: '카카오뱅크',
  토스뱅크: '토스뱅크',
  케이뱅크: '케이뱅크',
  제주은행: '제주은행',
  우체국: '우체국',
  한국씨티은행: '한국씨티은행',
  신협은행: '신협은행',
} as const

export const BanksArr = Object.keys(BANKS)

type BankNames = keyof typeof BANKS

export const SECURITIES = {
  미래에셋증권: '미래에셋증권',
  삼성증권: '삼성증권',
  KB증권: 'KB증권',
  한국투자증권: '한국투자증권',
  키움증권: '키움증권',
  대신증권: '대신증권',
  NH투자증권: 'NH투자증권',
  신한금융투자: '신한금융투자',
  하나증권: '하나증권',
  유안타증권: '유안타증권',
  현대차증권: '현대차증권',
  한화투자증권: '한화투자증권',
  교보증권: '교보증권',
  메리츠증권: '메리츠증권',
  DB금융투자: 'DB금융투자',
  하이투자증권: '하이투자증권',
  유진투자증권: '유진투자증권',
  SK증권: 'SK증권',
  신영증권: '신영증권',
  IBK투자증권: 'IBK투자증권',
  이베스트투자증권: '이베스트투자증권',
} as const

export const SecuritiesArr = Object.keys(SECURITIES)

type SecurityNames = keyof typeof SECURITIES

export type { BankNames, SecurityNames }
